import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Box, Typography } from '@mui/material';

const OEBarChart = ({ data }) => {
  console.log('=== OE CHART DEBUG ===');
  console.log('Data received:', data);
  console.log('Data type:', typeof data);
  console.log('Is array:', Array.isArray(data));
  console.log('Data length:', data ? data.length : 'null');

  // Handle empty or invalid data
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100%',
          flexDirection: 'column'
        }}
      >
        <Typography variant="h6" sx={{ color: '#666' }}>
          No OE data available
        </Typography>
        <Typography variant="body2" sx={{ color: '#999' }}>
          Received: {data ? `Array(${data.length})` : 'null/undefined'}
        </Typography>
      </Box>
    );
  }

  // Sort by value descending and take top 10
  const sortedData = data
    .sort((a, b) => b.value - a.value)
    .slice(0, 10);

  console.log('Sorted data for chart:', sortedData);

  return (
    <Box sx={{ width: '600px', height: '100%' }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          layout="vertical"
          data={sortedData}
          margin={{
            top: 5,
            right: 10,
            left: 10,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" />
          <YAxis dataKey="oe" type="category" width={140} />
          <Tooltip />
          <Bar dataKey="value" fill="#003781" />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default OEBarChart;